<template>
  <div
    class="basic_download_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    @dblclick="changeStyle('style')"
    :style="{'--theme_color': theme_color}"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="changeStyle('animation')"
        v-if="this.$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <!-- <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn> -->
    </div>
    <my_title_index :title="widgets_infor.title"></my_title_index>
    <div class="cate_info" v-if="isSystem" v-show="isPc">
        <span class="cate_title condition-cate-title" v-text="(typeName ?typeName : getLang('全部下载'))"></span>        
      </div>

    <div class="file_empty" v-if="fileList.length <= 0 && $store.state.app.view_pattern === 'pc'">
      <i class="empty_tips_img"></i>
      <div class="empty_tips_text">{{$t('widgets_basic_download_edit_506')}}</div>
    </div>
    <my_mb_empty_tips v-if="fileList.length <= 0 && $store.state.app.view_pattern === 'mb'"></my_mb_empty_tips>

    <!-- 横向布局 -->
    <div class="file_download_container" v-else-if="listArr.moduleStyle === 0">
      <div class="file_item list_header" :style="{
        ...backgroundStyle,
      }" v-if="fileList.length > 0">
        <div class="file_item_message">
          <div class="file_item_title" :style="{
            ...headerFontStyle,
           ...titleWidth
          }">{{$t('view_download_index_173')}}</div>
          <template v-if="$store.state.app.view_pattern === 'pc'">
            <div class="file_item_title file_item_summary" style="width:15%" :style="headerFontStyle">{{$t('widgets_basic_download_display_index_514')}}</div>
            <div class="file_item_title file_item_num" style="width:10%" :style="headerFontStyle">{{$t('widgets_basic_download_display_index_515')}}</div>
            <div class="file_item_title file_item_time" style="width:20%" :style="headerFontStyle">{{$t('widgets_basic_download_display_index_516')}}</div>
            <div class="file_item_size" style="width:10%" :style="headerFontStyle">{{$t('view_download_index_174')}}</div>
          </template>
        </div>
        <div class="file_item_download" :style="headerFontStyle">{{$t('view_form_dialog_add_form_216')}}</div>
      </div>
      <div class="file_item" v-for="item in fileList" :key="item.id">
        <div class="file_item_message">
          <div class="file_item_title" :style="{
            ...fontStyle,
           ...titleWidth
          }">{{ item.title }}</div>
          <template v-if="$store.state.app.view_pattern === 'pc'">
            <div class="file_item_title file_item_summary" :style="fontStyle" style="width:15%">
              <p style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%">{{ item.summary }}</p>
            </div>
            <div class="file_item_title file_item_num" :style="fontStyle" style="width:10%">{{item.click}}</div>
            <div class="file_item_title file_item_time" :style="fontStyle" style="width:20%">{{ item.time  }}</div>
            <div class="file_item_size" :style="fontStyle" style="width:10%">{{ item.file && item.file.size ? item.file.size : 0 }}KB</div>
          </template>
        </div>
        <div class="file_item_download" @click="openEditForm($event)">
          <a
            class="file_download"
            href="javascript:;"
            target="_self"
          >{{$t('router_index_69')}}</a>
        </div>
      </div>
    </div>
    <div
      class="file_download_container2"
      :class="{view_pattern_mb: $store.state.app.view_pattern === 'mb'}"
      v-else-if="listArr.moduleStyle === 1">
      <div class="file_item_wrap" v-for="item in fileList" :key="item.id" :style="{
        borderRadius: pc_infor.borderRadius[pc_infor.borderRadius.radio_val].value + 'px',
      }">
        <div class="file_item">
          <div class="file_icon">
            <img v-if="/pdf/i.test(item.fileFormat)" src="@/assets/image/icon_pdf.png" />
            <img v-else-if="/doc.?/i.test(item.fileFormat)" src="@/assets/image/icon_docx.png" />
            <img v-else-if="/ppt.?/i.test(item.fileFormat)" src="@/assets/image/icon_pptx.png" />
            <img v-else-if="/xl.{1,2}/i.test(item.fileFormat)" src="@/assets/image/icon_xlsx.png" />
            <img v-else-if="/(rar|zip|gz)/i.test(item.fileFormat)" src="@/assets/image/icon_rar.png" />
            <img v-else-if="/mp4/i.test(item.fileFormat)" src="@/assets/image/icon_video.png" />
            <img
              v-else-if="/(jpg|jpeg|gif|png|svg)/i.test(item.fileFormat)"
              src="@/assets/image/icon_img.png"
            />
            <img v-else src="@/assets/image/icon_unkonw.png" />
          </div>
          <div class="file_item_message">
            <div class="file_item_title" :style="fontStyle">{{ item.title }}</div>
            <div class="file_item_size" :style="fontStyle">{{ item.file && item.file.size ? item.file.size : 0 }}KB</div>
          </div>
          <div class="file_item_download" @click="openEditForm($event)">
            <a
              class="file_download"
              href="javascript:;"
              target="_self"
            >
              <img class="icon_download" src="@/assets/image/icon_download.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <my_page_index
      v-if="pc_widgets_infor.page.radioValue && fileList.length > 0"
      :page="pc_widgets_infor.page"
      :currentPage.sync="currentPage"
      :total="total"
      @change-page="changePage"
    ></my_page_index>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { basic_download_new_style, getCommonStyle } from "@/base/widgets_data_compatible";
import { getArticleListBy1 } from "@/api/app.js";

export default {
  name: 'basic_download_display_index',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },

  computed: {
    isPc() {
      return this.$store.state.app.view_pattern === "pc";
    },
    theme_color () {
      return this.$store.state.myRender.common.theme_color
    },
    widgets_infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    pc_widgets_infor () {
      return this.module.data.pc_widgets_infor;
    },
    listArr () {
      return this.module.data.listArr
    },
    fontStyle () {
      let pc_widgets_infor = this.module.data['pc_widgets_infor'];
      let fontStyle = {
        ...pc_widgets_infor.font[pc_widgets_infor.font.radio_val],
        fontSize: pc_widgets_infor.font[pc_widgets_infor.font.radio_val].fontSize + 'px'
      };
      return fontStyle;
    },
    headerFontStyle () {
      let pc_widgets_infor = this.module.data['pc_widgets_infor'];
      let fontStyle = {
        ...pc_widgets_infor.header_font[pc_widgets_infor.header_font.radio_val],
        fontSize: pc_widgets_infor.header_font[pc_widgets_infor.header_font.radio_val].fontSize + 'px'
      };
      return fontStyle;
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    // fileList () {
    //   return this.templet.pageShowList(this.listArr.fileList, this.pc_widgets_infor.page, this.currentPage)
    // }
    backgroundStyle() {
      if (this.pc_widgets_infor.background.radio_val === 'hidden') {
        return {
          background: 'transparent'
        }
      }
      return {
        backgroundColor: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].color,
        backgroundImage: 'url(' + (this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].img || '') + ')',
        backgroundSize: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].background_size,
        backgroundRepeat: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].background_repeat,
        backgroundPosition: this.pc_widgets_infor.background[this.pc_widgets_infor.background.radio_val].background_position,
      }
    },
    titleWidth() {
      return this.$store.state.app.view_pattern === 'pc' ? { width: '0px', flex: '1 1 auto' } : { width: '100%'}
    }
  },
  data () {
    return {
      isHover: false,
      currentPage: 1,
      fileList:[],
      isReset: false,
      total: 0,
      isSystem: this.module.data.isSystem === "true" ? true : false,
      typeName:
        this.$route.query.name !== undefined ? this.$route.query.name : "",
    };
  },
  created() {
      const listArr = this.module.data.listArr;
      const data = basic_download_new_style();
      if (typeof listArr.download_form == "undefined") {
        this.$set(listArr, "download_form", data.download_form);
      }
      // 设置留言表单的默认值
      if (listArr.download_form.custom.value == "" && this.$store.state.app.formList.length > 0) {
        this.$set(listArr.download_form.custom, "value", this.$store.state.app.formList[0].id);
        this.$set(listArr.download_form.default, "value", this.$store.state.app.formList[0].id);
      }
  },
  mounted () {
    this.fixField()
    this.get_list();
  },
  watch:{
    'pc_widgets_infor.page':{
      deep: true,
      handler(val) {
        this.page_reset();
        this.get_list();
      },
    },
  },
  methods: {
    page_reset() {
      this.isReset = true;
      this.currentPage = 1;
      this.total = 0;
    },
    getForm(id, data) {
      let obj = {};
      if (id !== "") {
        for (let i = 0; i < data.length; i++) {
          if (data[i].value === id) {
            obj = data[i];
            break;
          }
        }
      }
      return obj;
    },
    openEditForm($event) {
      if(this.templet.amp_no_make()){
        return
      }
      if(this.listArr.download_form.radio_val == 'custom' && this.listArr.download_form.custom.value !== '') {
          $event.preventDefault();
          this.templet.clickTime(() => {
          if (this.listArr.download_form.custom.value !== "") {
            let form = this.getForm(
              this.listArr.download_form.custom.value,
              this.$store.state.app.formList
            );
            this.$store.commit("app/set_submit_form_isShow", true);
            this.$store.commit("app/set_form", form);
          }
        });
      }
    },
    module_isHover (val) {
      this.isHover = val;
    },
    changeStyle (tabName) {
      this.templet.changeStyle(this.module, tabName)
    },

    get_list(that_data, type = "index") {
      this.loading = true;
      const query = {
        type: 4,
        rows: 10,
        page: 1,
        category_id:this.$route.query.id,
        is_up: "true",
      };

      if (this.module && this.module.data) {
        let page = this.module.data.pc_widgets_infor.page;

        if (this.listArr.module_style !== 1 && page.radioValue) {
          //需要分页
          query.rows = page.pageSize;
          query.page = this.currentPage;
        } else {
          query.rows = 999999;
          query.page = 1;
        }
      }
      getArticleListBy1(query)
        .then((e) => {
          if (
            e.code == 200 &&
            e.data &&
            e.data.rows &&
            e.data.rows instanceof Array
          ) {
            e.data.rows.map((item)=>{
              item.time = this.$moment(item.updatetime * 1000).format('YYYY-MM-DD')
              item.fileFormat = item.file_name
            })
            this.total = e.data.total;
            //list是组件index.vue中渲染试图的变量
            //不同的分页，渲染方式不同
            if (type == "index") {
              const page = this.module.data.pc_widgets_infor.page;
              if (page.radioValue && page.pageStyle == 2) {
                //展开更多，数据插入，不是数据重写
                if (this.isReset) {
                  this.isReset = false;
                  this.fileList = [];
                }
                e.data.rows.map((item) => {
                  this.fileList.push(item);
                });
              } else {
                this.fileList = e.data.rows;
              }
              // console.log(that_data.pc_infor.showAll)
              if (!this.pc_infor.page.radioValue) {
                this.fileList = this.fileList.slice(0, 200);
              }
            } else {
              //this.se_list = this.pro_data_filter(e.data.rows);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    changePage(val) {
      this.currentPage = val;
      this.get_list();
    },
    fixField() {
      if (typeof this.pc_infor.borderRadius == "undefined") {
        this.$set(this.pc_infor, "borderRadius", getCommonStyle().borderRadius);
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";
.basic_download_index {
  // height: 100%;
  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
  .cate_info{
    padding: 10px 10px 0px 10px;
    font-size: 14px;
    .cate_title{
      font-weight: bold;
    }
  }
  .file_empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 90px 0;
    .empty_tips_img {
      display: block;
      width: 157px;
      height: 123px;
      margin: 0 auto 28px;
      background: url(~@/assets/image/default_icon.png) 0 0;
    }
    .empty_tips_text {
      margin-bottom: 28px;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .file_download_container {
    .file_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 9px 0 9px;
      height: 58px;
      border-bottom: 1px dashed #e7e7e7;
      background: #fff;
      font-size: 14px;
      .file_item_message {
        overflow: hidden;
        flex: 1;
        display: flex;
        justify-content: space-between;
        margin-right: 5.8%;
        width: 86%;
        .file_item_title {
          padding-right: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .file_item_size {
          padding-right: 10px;
          flex: 0 0 80px;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .file_item_download {
        flex: 0 0 80px;
        min-width: 80px;
        height: 34px;
        background: #f2f3f5;
        border-radius: 3px;
        text-align: center;
        box-sizing: border-box;
        padding: 0 10px;
        a {
          display: inline-block;
          line-height: 34px;
          color: #657180;
          text-decoration: none;
          font-size: 14px;
          font-weight: 400;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .file_download_container2 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0 0 10px 0;
    .file_item_wrap {
      width: 31.6%;
      height: 100px;
      margin: 10px 0.7%;
      border: 1px solid rgba(240, 240, 240, 1);
      border-radius: 2px;
      display: flex;
      align-items: center;
      flex-shrink: 1;
      background: #fff;
      .file_item {
        width: 90%;
        height: 48px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .file_icon {
          flex: 0 0 48px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 48px;
          height: 48px;
          img {
            overflow: hidden;
            width: 100%;
            border-radius: 5px;
          }
        }
        .file_item_message {
          overflow: hidden;
          flex: 1;
          display: flex;
          flex-direction: column;
          width: 70%;
          margin: 20px 12px;
          .file_item_title {
            padding-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .file_item_size {
            padding-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .file_item_download {
          min-width: 48px;
          flex: 0 0 48px;
          height: 30px;
          background: rgba(242, 243, 245, 1);
          border-radius: 15px;
          text-align: center;
          .file_download {
            display: inline-block;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #000;
            font-weight: bolder;
            line-height: 30px;
            .icon_download {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
}
.pc_pattern {
  .file_item_download {
    &:hover {
      background: var(--theme_color) !important;
      a {
        color: #fff !important;
      }
    }
  }

}
.mb_pattern {
  .basic_download_index {
    .file_item_wrap {
      width: 92.6%;
      height: 76px;
      margin: 0 3.7%;
      border: none;
      border-bottom: 1px dashed rgba(240, 240, 240, 1);
      display: flex;
      align-items: center;
    }
  }
}
.list_header{
  font-size: 16px;
  height: 50px;
  .file_item_download{
    background: transparent !important;
    height: auto !important;
  }
  .file_item_download:hover{
     background: transparent !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_download_display/index.vue